{ "version": "1.4.47 (2026-04-07)" }
